import Status from "components/common_components/Status";

export const Immigration = [
    { index: 0, id: "fileNo", disablePadding: true, label: "File #" },
    { index: 1, id: "workStatus", label: "Status", render: (_, { value }) => <Status id={value} withIcon /> },
    { index: 2, id: "assigneeUser.name", label: "Assignee", sortable: false },
    { index: 3, id: "type.type", disablePadding: true, label: "Type" },
    { index: 4, id: "client.fullName", label: "Client", sortable: false },
    { index: 5, id: "client.address", disablePadding: false, label: "Address" },
    { index: 6, id: "client.city", disablePadding: false, label: "City" },
    { index: 7, id: "client.homePhone", disablePadding: true, label: "Home Phone" },
];

export const Taxes = [
    { index: 0, id: "fileNo", disablePadding: true, label: "File #" },
    { index: 1, id: "workStatus", label: "Status", render: (_, { value }) => <Status id={value} withIcon /> },
    { index: 2, id: "assigneeUser.name", label: "Assignee", sortable: false },
    { index: 3, id: "type.type", disablePadding: true, label: "Type" },
    { index: 4, id: "client.fullName", label: "Client", sortable: false },
    { index: 5, id: "client.address", disablePadding: false, label: "Address" },
    { index: 6, id: "client.city", disablePadding: false, label: "City" },
    { index: 7, id: "client.homePhone", disablePadding: true, label: "Home Phone" },
];

export const Crime = [
    { index: 0, id: "fileNo", disablePadding: true, label: "File #" },
    { index: 1, id: "workStatus", label: "Status", render: (_, { value }) => <Status id={value} withIcon /> },
    { index: 2, id: "assigneeUser.name", label: "Assignee", sortable: false },
    { index: 3, id: "type.type", disablePadding: true, label: "Type" },
    { index: 4, id: "client.fullName", label: "Client", sortable: false },
    { index: 5, id: "client.address", disablePadding: false, label: "Address" },
    { index: 6, id: "client.city", disablePadding: false, label: "City" },
    { index: 7, id: "client.homePhone", disablePadding: true, label: "Home Phone" },
];

export const Injury = [
    { index: 0, id: "fileNo", disablePadding: true, label: "File #" },
    { index: 1, id: "workStatus", label: "Status", render: (_, { value }) => <Status id={value} withIcon /> },
    { index: 2, id: "assigneeUser.name", label: "Assignee", sortable: false },
    { index: 3, id: "type.type", disablePadding: true, label: "Type" },
    { index: 4, id: "client.fullName", label: "Client", sortable: false },
    { index: 5, id: "client.address", disablePadding: false, label: "Address" },
    { index: 6, id: "client.city", disablePadding: false, label: "City" },
    { index: 7, id: "client.homePhone", disablePadding: true, label: "Home Phone" },
];

export const Family = [
    { index: 0, id: "fileNo", disablePadding: true, label: "File #" },
    { index: 1, id: "workStatus", label: "Status", render: (_, { value }) => <Status id={value} withIcon /> },
    { index: 2, id: "assigneeUser.name", label: "Assignee", sortable: false },
    { index: 3, id: "type.type", disablePadding: true, label: "Type" },
    { index: 4, id: "client.fullName", label: "Client", sortable: false },
    { index: 5, id: "client.address", disablePadding: false, label: "Address" },
    { index: 6, id: "client.city", disablePadding: false, label: "City" },
    { index: 7, id: "client.homePhone", disablePadding: true, label: "Home Phone" },
];
